
import { Invoice } from '@model/invoice';
import { Globals } from '@theme/utils/globals';
import { PAYMENT } from '@theme/utils/functions';
import { Component, OnInit } from '@angular/core';
import { InvoiceFacService } from '@service/invoice/invoiceFac.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FactureAddComponent } from '../facture-add/facture-add.component';


@Component({
  selector: 'app-facture-show',
  templateUrl: './facture-show.component.html',
  styleUrls: ['./facture-show.component.scss']
})
export class FactureShowComponent implements OnInit {
  title: string = "";
  invoice: any;
  global = { country: Globals.country, device: Globals.device };
  payment = PAYMENT;
  userSession = Globals.user;

  constructor(
    public modale: NgbActiveModal,
    private modalService: NgbModal,
    private invoiceService: InvoiceFacService
  ) {
    this.invoice = this.invoiceService.getInvoice()
    this.title = "Détails de la facture N° " + this.invoice?.code
  }

  ngOnInit(): void {
  }

  editInvoice(row) {
    this.modalService.dismissAll()
    this.invoiceService.setInvoice(row)
    this.invoiceService.edit = true
    this.modal(FactureAddComponent, 'modal-basic-title', 'xl', true, 'static')
  }
  printerInvoice(row): void {
    this.invoiceService.getPrinter('SHOW', this.userSession?.agencyKey, this.userSession?.uuid, row?.uuid);
  }
  modal(component, type, size, center, backdrop) {
    this.modalService.open(component, {
      ariaLabelledBy: type,
      size: size,
      centered: center,
      backdrop: backdrop
    }).result.then((result) => { }, (reason) => { });
  }
}
